import {
  IconAgeFill,
  IconChairFill,
  IconChildFill,
  IconCircleBlockRegular,
  IconParkingFill,
  IconPetPawFill,
  IconWiFiRegular,
} from "@packages/icon-library";

export const MARKERS = {
  adult: { title: "place.conditions.adult", icon: IconAgeFill },
  animals: { title: "place.conditions.animals", icon: IconPetPawFill },
  child_chair: { title: "place.conditions.childChair", icon: IconChairFill },
  child_room: { title: "place.conditions.childRoom", icon: IconChildFill },
  nonsmoking: {
    title: "place.conditions.nonsmoking",
    icon: IconCircleBlockRegular,
  },
  parking: { title: "place.conditions.parking", icon: IconParkingFill },
  wifi: { title: "place.conditions.wifi", icon: IconWiFiRegular },
  work_alltime: { title: "", icon: "" },
};
